// Copied from reactcomponents/lib/utils.ts
// decode a base64 string to a utf-8 string
export function atob_utf8(value: string) {
  const value_latin1 = atob(value);
  return new TextDecoder("utf-8").decode(
    Uint8Array.from({ length: value_latin1.length }, (_, index) =>
      value_latin1.charCodeAt(index),
    ),
  );
}

// encode a utf-8 string to a base64 string
// vanilla btoa throws "InvalidCharacterError: String contains an invalid character"
// for non-latin1 characters
export function btoa_utf8(value: string) {
  const encoded = new TextEncoder().encode(value);
  // Process in chunks to avoid stack overflow from spread operator argument limit (~65k)
  const CHUNK_SIZE = 32768;
  let binary = "";
  for (let i = 0; i < encoded.length; i += CHUNK_SIZE) {
    binary += String.fromCharCode(...encoded.subarray(i, i + CHUNK_SIZE));
  }
  return btoa(binary);
}
